import styled from "@emotion/styled"
import { Dialog } from "@mui/material"
import * as api from "api"
import { ImageModel } from "api"
import CloseButton from "common/CloseButton"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import Slider, { SliderButtonsPositioned } from "common/Slider"
import { memo } from "react"

const Styled = {
  Dialog: styled(Dialog)`
    margin: 0 auto;
    max-width: 1200px;

    ${(p) => p.theme.breakpoints.up("md")} {
      width: calc(100% - 150px);
      .MuiDialog-paper {
        height: calc(100% - 90px);
      }
    }
  `,
  Gallery: styled.div`
    padding: 10px;
    ${SliderButtonsPositioned}
    ${(p) => p.theme.breakpoints.up("md")} {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      > div,
      .slider,
      .swiper {
        width: 100%;
        height: 100%;
      }
      .swiper-slide > div {
        height: 100% !important;
      }
    }
  `,
  RatioElement: styled(RatioElement)`
    background: red;
    > div {
      ${(p) => p.theme.breakpoints.up("md")} {
      }
    }
  `,
}

type GalleryDialogProps = {
  onClose: () => void
  images: api.ImageModel[]
  active: number | null
}

const VehicleChildDialog = ({
  onClose,
  images,
  active,
}: GalleryDialogProps) => (
  <Styled.Dialog open={active != null} onClose={onClose} fullWidth>
    <CloseButton onClick={onClose} />
    <Styled.Gallery>
      <Slider
        prefix="galley"
        spaceBetween={20}
        data={images}
        render={(image) => (
          <Styled.RatioElement ratio={1}>
            <ResponsiveModelImage
              image={image as ImageModel}
              imageSizes={["100vw", "1150px"]}
            />
          </Styled.RatioElement>
        )}
      />
    </Styled.Gallery>
  </Styled.Dialog>
)

export default memo(VehicleChildDialog)
